module.exports = __webpack_public_path__ + "img/schnittkante_opalgruen_ral6026.6f118af5.jpg";